import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ques-remove",
  "use": "icon-ques-remove-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ques-remove\">\n<circle cx=\"7.9987\" cy=\"7.99967\" r=\"6.16667\" stroke=\"#999999\" />\n<rect x=\"11.7578\" y=\"7.39941\" width=\"1.2\" height=\"7.51953\" rx=\"0.6\" transform=\"rotate(90 11.7578 7.39941)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol